import React from 'react'
import StaffDocumentsChart from './staff-document-chart'
import ClientDocumentsChart from './client-most-document-chart'
import BillingDocumentsPieChart from './billing-status-metrics-chart'
import DocumentByPayer from './documents-by-payer'
import DocumentByStatus from './documents-by-status'
import DocumentByTemplate from './documents-by-template'
const DocumentListChart = () => {
    return (
        <>
            <div className='col-md-12 my-3 p-0'>
                {/* <div className='d-flex flex-wrap gap2'> */}
                <div className='col-md-11 mx-auto  col-sm-12'>
                    <StaffDocumentsChart />
                </div>

                <div className='col-md-11 mx-auto  my-3  col-sm-12 '>
                    <BillingDocumentsPieChart />
                </div>
                {/* </div> */}
                <div className='col-md-11 mx-auto  col-sm-12'>
                    <ClientDocumentsChart />
                </div>

                <div className='col-md-11 mx-auto  col-sm-12'>
                    <DocumentByPayer />
                </div>

                <div className='col-md-11 mx-auto  col-sm-12'>
                    <DocumentByStatus />
                </div>

                <div className='col-md-11 mx-auto  col-sm-12'>
                    <DocumentByTemplate />
                </div>
            </div>


        </>

    )
}

export default DocumentListChart